export default class ConvertUtils{


    static getMBfromBytes(bytes: number){
        return Math.round(bytes / (1024 ** 2) * 10) / 10;
    }


}